import { useEffect, useState } from "react";
import { useFiscalPeriodsQuery } from "../api/reference";

export function useReportingPeriod() {
  const fiscal = useFiscalPeriodsQuery();
  const [period, setPeriod] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (fiscal.data?.defaultPeriod && period === undefined) {
      setPeriod(fiscal.data.defaultPeriod);
    }
  }, [fiscal.data?.defaultPeriod, period]);

  const effectivePeriod =
    period ?? fiscal.data?.defaultPeriod ?? fiscal.data?.months.at(-1) ?? "";

  return {
    period: effectivePeriod,
    setPeriod,
    months: fiscal.data?.months ?? [],
    fiscalYearName: fiscal.data?.fiscalYearName ?? "",
    startsOn: fiscal.data?.startsOn ?? "",
    endsOn: fiscal.data?.endsOn ?? "",
    isLoading: fiscal.isLoading,
  };
}
